import { Injectable } from '@angular/core';
import { ValidatorFn, AbstractControl } from '@angular/forms';

import * as momentN from 'moment'; const moment = momentN;

@Injectable()
export class ValidatePastDateValidator {
    static validateDate(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: boolean } | null => {
            
            const newDate = new Date();
            const currentDate = control.value;

            const newDateFormat = moment(newDate).startOf('day');
            const currentDateFormat = moment(currentDate).startOf('day');

            if (currentDateFormat < newDateFormat) {
                return { validDate: true };
            }

            return null;
        };
    }
}
